import { render, staticRenderFns } from "./No05.vue?vue&type=template&id=0649b448&scoped=true"
import script from "./No05.vue?vue&type=script&lang=js"
export * from "./No05.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649b448",
  null
  
)

export default component.exports